jQuery(document).ready(function() {
    'use strict';

    const cookieName = 'onBoarding';

    function getCookie(cookieName) {
        const name = cookieName + '=';
        const decodedCookie = decodeURIComponent(document.cookie);
        const ca = decodedCookie.split(';');

        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];

            while (c.charAt(0) === ' ') {
                c = c.substring(1);
            }

            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length);
            }

            console.log(ca);
        }

        return '';
    }

    let checkForCookie = false;
    try {
        checkForCookie = getCookie(cookieName);
    } catch (ex) {
        console.error(ex);
    }

    if (checkForCookie) {
        window.location.replace('/logga-in/');
    } else {
        window.location.replace('/onboarding/');
        //window.location.replace('/startsida/');
    }
});
